module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_112_3.6847c5ee.pdf";